/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { Division, Subhead, CTAs, InContentMessage, Icon } from '@insticator/insticator-ui'; // iui-material
import EditEmbedCTA from 'material/ctas/editembed/editembed_container';
import AnalyticsCTA from 'material/ctas/analytics/analytics_container';
import PortedToBeta from 'material/portedtobeta/portedtobeta';
// pages
import EmbedManagement from 'pages/dashboard/embeds/management/embed_management_container';
import EmbedAnalytics from 'pages/dashboard/embeds/analytics/embed_analytics_container';
import EmbedEmails from 'pages/dashboard/embeds/emails/embedemails_container';
import LibraryPage from 'pages/dashboard/embeds/library/library_container';
// utils
import { Route, Switch, Redirect } from 'react-router';
import { PrivateRoute } from '@insticator/insticator-ui'; // iui-utils
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/embeds/embeds_styles';


const portedToBetaComponent = () => <PortedToBeta 
  buttonText={'Go to Trivia & Polls Configuration'} 
  path={'dashboard/triviapolls/configuration'}
  body={<p>Trivia & Polls Configuration has been moved to <b>Publisher Portal V2 (Beta)</b></p>} 
/>

/* ========== ~~~~~~~~~~ EMBEDS SECTION ~~~~~~~~~~ ========== */
class Embeds extends Component {
    componentDidMount() {
        if (this.props.mockupGenerator && this.props.productCategory === 'CONTENT' && this.props.navigateToEmbedUUID) {
            this.props.editEmbed(this.props.navigateToEmbedUUID);
        }
        // else if (!this.props.isDataReceived) {
        //     this.props.getClientEmbedsData(this.props.accountUUID);
        // }
    }
    isLibraryPage = () => this.props.currentPage === 'dashboard/embeds';
    isAnalyticsPage = () => this.props.currentPage.includes('embedcontent');
    isCustomizePage = () => !this.isAnalyticsPage() && !this.isLibraryPage() && this.props.currentPage !== 'dashboard/embeds/management/code';
    handleEmbedName = () => {
         if(this.isLibraryPage()){
             return null
         } if (this.props.embedName || this.props.selectedEmbedName){
             return <span className={`uniquename embedname`}>{`/ ${this.props.selectedEmbedName ? this.props.selectedEmbedName : this.props.embedName}`}</span>
        } if (this.props.selectedEmailCollectionEmbedName) {
            return <span className={`uniquename embedname`}>{`/ ${this.props.selectedEmailCollectionEmbedName}`}</span>
        }
    };
    handleCTAs = () => {
        return this.isLibraryPage() ? null :
            <CTAs>
                {this.isAnalyticsPage() && this.props.editPermitted && !!this.props.selectedEmbedUUID ? <EditEmbedCTA selectedUUID={this.props.selectedEmbedUUID} /> : null}
                {this.isCustomizePage() && !!this.props.embedUUID ? <AnalyticsCTA /> : null}
            </CTAs>;
    };
    render() {
        if(!this.props.permissionsReceived) return null;
        const isInIframe = window.top !== window.self
        return(
            <Division name={`embeds`} klass={this.props.classes.embeds}>
                { isInIframe && 
                  <Subhead>
                      <h1 className = {'embedheadername'}>Trivia & Polls <Icon klass={'header-divider'} name={'chevron-right'} animation={'none'} /> Configuration {this.handleEmbedName()}</h1>
                      {this.handleCTAs()}
                  </Subhead>
                }
                <InContentMessage />
                <Switch>
                    {/*Routes to subsections*/}
                    <Route exact path='/dashboard/embeds' component={isInIframe ? LibraryPage : portedToBetaComponent} />
                    <Route path='/dashboard/embeds/analytics' component={isInIframe ? EmbedAnalytics : portedToBetaComponent} />
                    <Route path='/dashboard/embeds/emails' component={isInIframe ? EmbedEmails : portedToBetaComponent} />
                    <PrivateRoute permitted={this.props.editPermitted} path='/dashboard/embeds/management' component={isInIframe ? EmbedManagement : portedToBetaComponent} />
                    <Redirect to='/error/404' />
                </Switch>
            </Division>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Embeds);
